const key = 'b2e64fbf73098622';

export default key;


// WEBPACK FOOTER //
// ./src/apiKey.js